// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3r3LU","content":"RecentSearches_content__GDPUh"};